export default __webpack_public_path__ + "static/media/ponentes__Alicia-Silva.b63b6d4c.jpg";